import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { PortalShell } from "@/components/layout/PortalShell";
import { CLIENT_NAV } from "@/lib/client-nav";
import { AnnouncementsInbox } from "@/components/portal/AnnouncementsInbox";

export const Route = createFileRoute("/client/announcements")({
  head: () => ({ meta: [{ title: "Announcements — Family Command Center" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <ProtectedRoute requiredRole="client">
      <PortalShell title="Family Command Center" nav={CLIENT_NAV} tourKey="client_tour">
        <AnnouncementsInbox audience="client" />
      </PortalShell>
    </ProtectedRoute>
  ),
});